import { StyleSheet } from "react-native";

import { radii, spacing, type ThemeColors } from "~/styles/theme";

export const makeStylesheet = (colors: ThemeColors) =>
  StyleSheet.create({
    metricsGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    metric: {
      minWidth: 150,
      flex: 1,
    },
    formGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    field: {
      minWidth: 180,
      flex: 1,
      gap: spacing.xs,
    },
    wideField: {
      minWidth: 280,
    },
    smallField: {
      width: 112,
      gap: spacing.xs,
    },
    invoiceGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    listHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
    },
    emptyState: {
      minHeight: 96,
      justifyContent: "center",
      padding: spacing.l,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.m,
      backgroundColor: colors.surfaceSunken,
    },
    quickDraftPanel: {
      gap: spacing.m,
      padding: spacing.m,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.m,
      backgroundColor: colors.surfaceSunken,
    },
    quickDraftGrid: {
      gap: spacing.s,
    },
    quickDraftRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
      paddingVertical: spacing.s,
      borderBottomWidth: 1,
      borderBottomColor: colors.hairline,
    },
    invoiceButtonContent: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
    },
    invoiceButtonText: {
      flex: 1,
      minWidth: 0,
      gap: spacing.xs,
    },
    itemRow: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
      padding: spacing.m,
      borderRadius: radii.m,
      backgroundColor: colors.surfaceSunken,
    },
    detailPanel: {
      gap: spacing.m,
      padding: spacing.m,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.m,
      backgroundColor: colors.surfaceSunken,
    },
    editPanel: {
      flex: 1,
      minWidth: 260,
      gap: spacing.m,
    },
    historyRow: {
      gap: spacing.xs,
      paddingVertical: spacing.s,
      borderBottomWidth: 1,
      borderBottomColor: colors.hairline,
    },
    itemMain: {
      flex: 1,
      minWidth: 200,
      gap: spacing.xs,
    },
    itemTotals: {
      alignItems: "flex-end",
      gap: spacing.xs,
    },
    invoiceTotals: {
      gap: spacing.s,
      paddingTop: spacing.m,
      borderTopWidth: 1,
      borderTopColor: colors.hairline,
    },
    statusControls: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.s,
    },
    totalRow: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.m,
    },
  });
